"use strict";

const RoutineInspectionRouteFactory = require("./routineInspectionRouteFactory");

const BmpFcsRoutes = function () {
  const inspectionRoute = RoutineInspectionRouteFactory.createRoute({
    resourceKey: "bmpRoutineMaintenanceInspection",
    assetType: "bmpFcs",
  });

  const legacyRedirectRoute = RoutineInspectionRouteFactory.createLegacyRedirect({
    assetType: "bmpFcs",
    dataView: "muni-bmp",
  });

  return { inspectionRoute, legacyRedirectRoute };
};

module.exports = BmpFcsRoutes();
